import React from 'react';
import Tabs, { TabPane } from 'rc-tabs';
import TabContent from 'rc-tabs/lib/TabContent';
import ScrollableInkTabBar from 'rc-tabs/lib/ScrollableInkTabBar';
import 'rc-tabs/assets/index.css';
import { isEqual, isEmpty } from 'lodash';

export default class TitleTabPane extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            tabid: props.datas.currentTab
        }
        this.handleTabData = this.handleTabData.bind(this);
    }

    handleTabData(tabid){
        const { datas={} } = this.props;
        const { handleTabData={} } = datas;
        handleTabData(tabid);
        this.setState({
            tabid: tabid
        })
    }

    componentWillReceiveProps(nextProps){
        const { tabid } = this.state;
        if(!isEqual(tabid, nextProps.datas.currentTab)){
            this.setState({
                tabid: nextProps.datas.currentTab
            })
        }
    }

    render(){
        const { datas={}, fontStyle, ebaseid = '' } = this.props;
        const { tabid } = this.state;
        const { config={}, isShowSettingShowType='0' } = datas;
        const { item={} } = config;
        const { header={} } = item;
        if(isEmpty(datas)) return <div/>;
        const { currentTab='1', tabids = [], titles = [], methodvalue,tabwidth,counts } = datas;
        const tdStyle={width: 'auto', verticalAlign: 'top',backgroundSize: '100% 100%', height: '32px'};
        const tdStyle1={width: 'auto', marginRight: '10px', verticalAlign: 'top',backgroundSize: '100% 100%', height: '32px'};
        let style = {marginLeft: '10px', marginRight: '10px'};
        let style1 = {width: tabwidth + 'px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'block'};
        let titleStyle = {width: '100%'};
        // if(header.canHeadbar) titleStyle={width: 'calc( 100% - 95px )'}
        let tHtml_new = (
            <Tabs
                activeKey={tabid}
                renderTabBar={()=><ScrollableInkTabBar />}
                renderTabContent={()=><TabContent />}
                className="tabcontainer tab2"
                style={titleStyle}
            >
                {
                    titles.map((title, i)=> {
                        if ((ebaseid == '8') && counts && counts[i] !== -1 && counts[i] !== '' && counts[i] !== null) {
                            title +=' (' + counts[i] + ')';
                        }else if (ebaseid == 'blogStatus' && counts && '0'!== counts[i]) {
                            title += ' (' + counts[i] + ')';
                        }else if(ebaseid == '7_DY'&& counts && '0'!== counts[i]){
                            title += ' (' + counts[i].noReadNum + ')';
                        }else if(isShowSettingShowType == '1' && ebaseid == '7'&& counts && counts[i] && counts[i].noReadNum){
                            title += ' (' + counts[i].noReadNum + ')';
                        }else if(ebaseid == '7'&& counts && counts[i] && counts[i].isHaveNoRead && counts[i].isHaveNoRead == '1'){
                            title =  title;
                        }
                        const className = tabids[i] == tabid ? `tab2selected wea-f${fontStyle.tab1fontsize || 12}` : `tab2unselected wea-f${fontStyle.tab2fontsize || 12}`;
                        const pointClassName = ebaseid == '7'&& counts && counts[i] && counts[i].isHaveNoRead && counts[i].isHaveNoRead == '1' ? 'portal-new-unreadpoint' : '';
                        return <TabPane key={i+1} style={{width: '200px'}} tab={<div title={title} className={className} style={methodvalue == '2' ? tdStyle1 : tdStyle} data-tabid={tabids[i]}  onClick={() => this.handleTabData(tabids[i])}><span style={methodvalue == '2' ? style:style1}>{title}<div className={pointClassName}></div></span></div>}></TabPane>
                    })
                }
            </Tabs>
        )
        return tHtml_new;
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/TitleTabPane.js